import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { CheckCircle, Briefcase, Globe, Building2, Star, Users, Quote, User } from 'lucide-react';
import boardImg from "../../images/homepage/boardmembers_.jpeg";
import law from "../../images/homepage/law.png";
import shield1 from "../../images/homepage/shield1.png";
import shield2 from "../../images/homepage/shield2.png";
import shield3 from "../../images/homepage/shield3.png";
import justice from "../../images/homepage/justice.jpeg"
import regulatoryCompliance from "../../images/homepage/Regulatory Compliance.jpeg 16-52-20-730.jpeg";
import realEstateAdvisory from "../../images/homepage/Real Estate Advisory.jpeg 16-51-55-362.jpeg";
import immigrationConsultancy from "../../images/homepage/Immigration consultancy.jpeg 16-51-55-203.jpeg";
import debtRecoveryService from "../../images/homepage/Debt recovery service.jpeg";
import litigationAndArbitration from "../../images/homepage/Litigation and Arbitration.jpeg";
import familyLaw from "../../images/homepage/Family law.jpeg";


const Home = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get("https://backend.lawberonlegals.com/api/articles");
        setArticles(response.data);
      } catch (err) {
        setError("Failed to load articles, check your internet connection and refresh the page.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);
  const services = [
    {
      name: "💼 Corporate Law",
      desc: "Company registration, M&A, shareholder agreements, and restructuring.",
      path: "/services",
      image: regulatoryCompliance,
    },
    {
      name: "🧠 Intellectual Property",
      desc: " Trademark, copyright, licensing & enforcement in Nigeria.",
      path: "/services",
      image: realEstateAdvisory,
    },
    {
      name: "💸 Fintech & Regulatory Advisory",
      desc: " Digital finance licensing (CBN, SEC, NITDA), compliance & crypto guidance.",
      path: "/services",
      image: immigrationConsultancy,
    },
    {
      name: "🏗️ Real Estate & Property Law",
      desc: "Due diligence, land acquisition, title perfection, estate structuring.",
      path: "/services",
      image: debtRecoveryService,
    },
    {
      name: "🧾 Tax & Wealth Structuring",
      desc: "Legal strategies to minimize risk and maximize return.",
      path: "/services",
      image: familyLaw,
    },
    {
      name: "👨‍⚖️ Dispute Resolution",
      desc: "Business litigation, arbitration, and commercial conflict management.",
      path: "/services",
      image: litigationAndArbitration,
    },
  ];


  const industries = [
    { name: 'Nigerian Entrepreneurs', icon: <Users size={24} /> },
    { name: 'Foreign Founders', icon: <Globe size={24} /> },
    { name: 'Tech Startups', icon: <Star size={24} /> },
    { name: 'Real Estate Developers', icon: <Building2 size={24} /> },
    { name: 'High-Net-Worth Individuals', icon: <Briefcase size={24} /> },
    { name: 'Content Creators', icon: <Users size={24} /> },
  ];

  const usps = [
    'Business-savvy, tech-literate lawyers',
    'Regulatory deep expertise',
    'Dual support for local and foreign clients',
    'Swift turnaround time',
    'Discreet and client-first',
  ];

  const testimonials = [
    {
      name: 'Marie Dupont',
      title: 'Founder, Global Synergy (France)',
      category: 'Foreign business client',
      quote:
        'Navigating Nigerian legal requirements was made seamless with their expert, client-first approach. We now consider them a vital part of our international expansion.',
    },
    {
      name: 'Chinedu Okafor',
      title: 'CEO, GreenRoots Nigeria',
      category: 'Nigerian entrepreneur',
      quote:
        'Their team is not just legally brilliant—they understand how to support startups from incorporation to funding rounds. I recommend them without hesitation.',
    },
    {
      name: 'Tola Adebayo',
      title: 'Creative Director, VisionInk Studios',
      category: 'Creative industry stakeholder',
      quote:
        'For the first time, I felt legally empowered as a content creator. Their discreet and tech-savvy counsel made all the difference in securing my rights.',
    },
  ];

  return (
    <section>
      <section className="workSans">
        <div
          className="relative bg-cover bg-center"
          style={{ backgroundImage: `url(${boardImg})` }}
        >
          {/* Dark overlay */}
          {/* <div className="absolute inset-0 bg-[#052137fa] opacity-50"></div> */}
          <div className="relative z-10 md:w-[65%] p-[6%]">
            <div className="relative bg-black/30 p-2">
              <h1 className="text-[20px] md:text-[32px] font-[600] my-2 md:pt-[5%] text-white">
                Empowering Business With Expert Legal & Corporate Solutions
              </h1>
              <p className="font-[500] text-white">
                At Lawberon Legals & Co, we provide comprehensive legal and corporate consulting services designed to help businesses navigate complex challenges. Our team of experts delivers tailored strategies that ensure your organization thrives in today’s dynamic marketplace.
              </p>
            </div>
            <button type="button" className="bg-[#052137] my-[3%] text-white px-6 py-2 rounded-md font-semibold">
              <Link to="/about">Read more</Link>
            </button>
          </div>
        </div>
      </section>


      <section className="px-[6%] workSans">
        <div className="md:flex justify-between items-center gap-4 my-[3%]">
          <div className="md:w-[80%] flex gap-4 items-start">
            <div>
              <img src={law} className="md:w-[100px]" alt="the law" />
            </div>
            <div>
              <p className="text-[24px] font-[600]">Our Practice Areas—Built Around Business Success</p>
              <p className="text-[15px] text-[#000000c3]">
                Whether you're launching a startup, acquiring property, registering your trademark, or resolving a complex dispute—we’ve got you covered.
              </p>
            </div>
          </div>
          <div>
            <button type="button" className="bg-[#052137] my-[3%] text-white px-6 py-2 rounded-md font-semibold">
              <Link to="/services">View All Services</Link>
            </button>
          </div>
        </div>


        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {services.map((item, index) => (
            <div
              className="relative bg-cover bg-center rounded-[10px] h-80 flex flex-col justify-between text-white"
              key={index}
              style={{
                backgroundImage: `url('${item.image}')`,
              }}
            >
              <div className="h-80 px-4 py-4 rounded-[6px] transition-colors duration-300 hover:bg-[#052137] hover:bg-opacity-80">
                <div className="absolute bottom-0 py-[4px] px-[4px] bg-black bg-opacity-50 h-fit">
                  <p className="text-[24px] font-[600] text-[#fff] py-4">{item.name}</p>
                  <p className="text-[16px] text-[#fff]">{item.desc}</p>
                  <p className="text-[#d11c1c] underline"><Link to={item.path}>Read more</Link></p>
                </div>
              </div>
            </div>
          ))}
        </div>


        <div className="bg-white p-8 sm:p-12 my-[4%] md:flex md:items-center gap-10 shadow-lg rounded-2xl max-w-7xl mx-auto">
          {/* Left Section */}
          <div className="flex-1">
            <h2 className="text-[#052137] text-3xl font-bold flex items-center gap-2 mb-2">
              <img src={law} className="md:w-[60px]" alt="the law" />
              About Us
            </h2>
            <p className="text-lg text-gray-600 font-semibold mb-4">
              Trusted Expertise for All Your Legal Needs
            </p>
            <p className="text-gray-500 mb-6">
              Lawberon Legals & Co. is a full-service business law firm based in Lagos, Nigeria, with a global outlook and a deep understanding of local regulations. We provide smart, strategic, and industry-specific legal solutions to entrepreneurs, foreign investors, startups, corporates, and high-net-worth individuals doing business in Nigeria or across borders.
            </p>

            {/* Service Features */}
            <div className="flex flex-wrap gap-4 mb-6">
              {[
                { icon: shield1, text: "Ontime at Services" },
                { icon: shield2, text: "Available at Your Location" },
                { icon: shield3, text: "Online Appointment" },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center bg-[#052137] bg-opacity-90 text-white p-4 rounded-xl w-36"
                >
                  <img src={feature.icon} alt="law" className="text-4xl mb-2" />
                  <p className="text-sm font-medium">{feature.text}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="bg-[#052137] text-white font-semibold px-6 py-2 rounded-md transition"
            >
              VIEW ALL ABOUT US
            </Link>
          </div>

          {/* Right Section */}
          <div className="relative flex-shrink-0 w-full mt-2 md:w-2/5">
            <img
              src={justice}
              alt="Justice"
              className="rounded-lg w-full object-cover"
            />
            <div className="absolute bottom-4 left-4 bg-[#052137] text-white text-lg font-bold px-4 py-2 rounded-md shadow-lg">
              <span className="text-3xl">25</span> Year Experience
            </div>
          </div>
        </div>

        <section className="px-6 md:px-16 py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-4">Who We Serve</h2>
            <p className="text-lg text-gray-600 mb-10">
              Tailored legal solutions for business leaders, creatives, and foreign investors.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {industries.map((industry, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl border border-gray-100 transition transform hover:-translate-y-1"
                >
                  <div className="mb-4 text-[#d11c1c]">{industry.icon}</div>
                  <h4 className="text-lg font-semibold">{industry.name}</h4>
                </div>
              ))}
            </div>
            <button className="mt-10 bg-[#052137] text-white px-8 py-3 rounded-full font-medium hover:bg-[#0a335c] transition">
              <Link to="/industries">See Industry Solutions</Link>
            </button>
          </div>
        </section>

        {/* Section: Signature Services */}
        <section className="px-6 md:px-16 py-20 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-4">Signature Services</h2>
            <p className="text-lg text-gray-600 mb-10">
              Why top-tier clients trust us
            </p>

            <div className="grid sm:grid-cols-2 text-center gap-6 text-left">
              {usps.map((point, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#d11c1c] mt-1" />
                  <p className="text-md text-gray-800">{point}</p>
                </div>
              ))}
            </div>

            {/* Trust Logos */}
            <div className="flex gap-4 mt-12 flex-wrap">
              <span className="px-5 py-2 rounded-full bg-gray-100 text-sm font-medium shadow-sm">CAC Certified</span>
              <span className="px-5 py-2 rounded-full bg-gray-100 text-sm font-medium shadow-sm">NIPC Partner</span>
              <span className="px-5 py-2 rounded-full bg-gray-100 text-sm font-medium shadow-sm">NBA Member</span>
            </div>
          </div>
        </section>

        <section className="px-6 md:px-16 py-20 bg-gray-50 text-[#052137]">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-2">❤️ Testimonials</h2>
            <p className="text-lg text-gray-600 mb-12 italic">What our clients say about us</p>

            <div className="grid gap-8 md:grid-cols-3">
              {testimonials.map((item, index) => (
                <div
                  key={index}
                  className="relative bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition border border-gray-100 flex flex-col"
                >
                  <Quote className="absolute top-6 right-6 text-[#d11c1c] opacity-20" size={32} />
                  <p className="text-gray-800 text-sm mb-6">“{item.quote}”</p>
                  <div className="mt-auto pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-3 mt-4">
                      <div className="bg-[#d11c1c] text-white rounded-full p-2">
                        <User size={18} />
                      </div>
                      <div className="text-left">
                        <p className="font-semibold">{item.name}</p>
                        <p className="text-xs text-gray-500">{item.title}</p>
                        <span className="text-xs text-[#d11c1c]">{item.category}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="mt-10 bg-[#052137] text-white px-8 py-3 rounded-full font-medium hover:bg-[#0a335c] transition">
              <Link to="/book">Speak with a Consultant</Link>
            </button>
          </div>
        </section>


        <div className="container mx-auto p-6 px-[7%]">
          <h1 className="text-3xl font-semibold text-[#052137]">Legal Insights</h1>
          <p className="text-gray-700 mb-4">Insights and Analysis on Key Legal Issues</p>

          <section className="my-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
              {loading && (
                <p className="text-center text-lg font-semibold">Loading articles...</p>
              )}
              {error && (
                <p className="text-center text-red-500">{error}</p>
              )}
              {articles.slice(0, 3).map((article) => (
                <div key={article._id} className="bg-white shadow-lg rounded-lg overflow-hidden">
                  <img
                    src={article.coverImage || "https://via.placeholder.com/300"}
                    alt={article.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <Link to={`/insights/${article.title.toLowerCase().replace(/\s+/g, '-')}`}>
                      <h3 className="text-lg font-semibold hover:text-red-500">{article.title}</h3>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Button */}
          <div className="flex justify-center mt-6">
            <Link to="/insights">
              <button className="bg-[#052137] text-white px-6 py-2 rounded-md">
                VIEW ALL ARTICLES
              </button>
            </Link>
          </div>
        </div>

      </section>


    </section>
  )
}

export default Home;
